import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SoundsService {
  notificationAudio: any = null;
  constructor() {
    this.notificationAudio = new Audio('sounds/mixkit-long-pop-2358.mp3');
  }
  notificationSound() {
    if (this.notificationAudio === null) return;
    this.notificationAudio.play();
  }
}
